export interface BatchStatisticsReferenceRequest {
  dateFrom: string
  dateTo: string
  branchCodeFrom: string
  branchCodeTo: string
  isAllBranchOnly: boolean
  isOutputReference: boolean
  isOutputEvent: boolean
  memo: string
  batchType: string
}

export function BatchStatisticsReferenceRequestToJSON(
  value: BatchStatisticsReferenceRequest
): any {
  return {
    date_from: value.dateFrom,
    date_to: value.dateTo,
    branch_code_from: value.branchCodeFrom,
    branch_code_to: value.branchCodeTo,
    is_all_branch_only: value.isAllBranchOnly,
    is_output_reference: value.isOutputReference,
    is_output_event: value.isOutputEvent,
    memo: value.memo,
    batch_type: value.batchType
  }
}
